import { Box, Image } from '@modusign/design-system';

import FeatureBlockViewContent from '@app/components/FeatureBlockViewContent';
import { ADDRESS_BOOK_HELP_URL } from '@app/features/addressBook/constants';
import { planTitle } from '@app/libs/planTitle';

import AddressBookFeatureDescription from './AddressBookFeatureDescription';

export default function SettingsAddressBookBlockPage() {
  return (
    <FeatureBlockViewContent featurePlan={planTitle(3)} url={ADDRESS_BOOK_HELP_URL}>
      <Box maxWidth="560px" mt={9} pb={6} pt={7} px={[7, null, 8]}>
        <Image
          src="https://cdn.modusign.co.kr/assets/image/img/img-address-book.gif"
          width={['100%', '500px']}
        />
        <AddressBookFeatureDescription />
      </Box>
    </FeatureBlockViewContent>
  );
}
